import { StringUtils } from './string.utils';
import { environment } from '../../environments/environment';
import { IGlueUrlConfig } from '../models/settings.model';

export class UrlUtils {
  static getCategoryNameFromUrl(url: string): string {
    const chunks: string[] = url.split('/');
    return chunks.at(-1) ?? '';
  }

  static serialize(obj: any, prefix: string = ''): string {
    const str: string[] = [];
    for (const p in obj) {
      if (Object.hasOwn(obj, p)) {
        const k: string = prefix ? prefix + '[' + p + ']' : p;
        const v: any = obj[p];
        str.push((v !== null && typeof v === 'object') ?
          this.serialize(v, k) :
          k + '=' + encodeURIComponent(v));
      }
    }
    return str.join('&');
  }

  static getLocaleFromPathName(pathName: string): string {
    return StringUtils.substringFromChar(pathName.substring(1, pathName.length), '/');
  }

  static getGlueUrlForStore(storeId: string): string {
    const configuration: IGlueUrlConfig[] = environment.glueApiUrl as IGlueUrlConfig[];
    const urlConfig: IGlueUrlConfig = configuration.find(c => c.store === storeId) as IGlueUrlConfig;
    return urlConfig.url;
  }

  static isTheSameRoute(route: any): boolean {
    const previousPath: string = route[0].state._root.children[0].value.routeConfig.path;
    const newPath: string = route[1].state._root.children[0].value.routeConfig.path;
    return previousPath === newPath;
  }
}
